import { render, staticRenderFns } from "./ManageOfficer.vue?vue&type=template&id=4c84bfe5&"
import script from "./ManageOfficer.vue?vue&type=script&lang=js&"
export * from "./ManageOfficer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports